import {
    ChatProviderInstance,
    ChatTypeName,
} from '@sxm-core/utility-code/angular/configuration-token-chat-provider-instance';

type Ids247 =
    | 'chat-247-Link-body1'
    | 'chat-247-Link-body2'
    | 'chat-247-Link-body3';
type Queue = 'general' | 'cancel' | 'agents';
const queueMappings: {
    [key in Queue]: Ids247;
} = {
    general: 'chat-247-Link-body1', // this is for the BOT
    cancel: 'chat-247-Link-body2',
    agents: 'chat-247-Link-body3', // this is for actual Agents
};

export class ChatProvider247 implements ChatProviderInstance {
    name = '247' as ChatTypeName;

    init(
        queue: Queue = 'general',
        targetElement: HTMLElement,
        enabledCallback: () => unknown,
    ) {
        targetElement.id = queueMappings[queue] || queueMappings.general;
        return this.waitForChatEnabled(targetElement, enabledCallback);
    }

    private waitForChatEnabled(
        targetElement: HTMLElement,
        enabledCallback: () => unknown,
    ) {
        const observer = new MutationObserver((mutationsList, _observer) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'attributes') {
                    if (
                        this.chatLinkHasCssClassAppliedFromTwentyFourSeven(
                            targetElement,
                        )
                    ) {
                        enabledCallback();
                        _observer.disconnect();
                    }
                }
            });
        });

        observer.observe(targetElement, {
            attributes: true,
            childList: false,
            subtree: false,
        });
        return observer;
    }

    private chatLinkHasCssClassAppliedFromTwentyFourSeven(
        targetElement: HTMLElement,
    ): boolean {
        return (
            targetElement.classList.contains('chat-enabled') ||
            targetElement.classList.contains('chat-engage') ||
            targetElement.classList.contains('chat-engaged')
        );
    }
}
